import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MaterialModule } from '../material/material.module';
import { FileUploadComponent } from './file-upload.component';

@NgModule({
    declarations: [FileUploadComponent],
    imports: [
        CommonModule,
        FlexLayoutModule,
        MaterialModule
    ],
    exports: [FileUploadComponent]
})
export class FileUploadModule { }
